import React from "react";
import Sidebar from "./Sidebar.component";
import styles from "./home.module.scss";

interface SidebarLayoutProps {
  children: React.ReactNode;
}

const SidebarLayout: React.FC<SidebarLayoutProps> = ({ children }) => {
  return (
    <div className={styles.sidebarLayout}>
      <Sidebar showClientList={false} />
      <div className={styles.sidebarLayout__content}>{children}</div>
    </div>
  );
};

export default SidebarLayout;
